import {Injectable} from '@angular/core';
import {CountResponse, DataOBJ, DataObjService, RestService} from './rest-service';
import {PhoneNumber} from './phone-number.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Department, DepartmentService} from './department.service';
import {CostCenter, CostCenterService} from './cost-center.service';
import {isNullOrUndefined} from 'util';

@Injectable()
export class ExtensionService implements DataObjService<Extension> {

  restHelper: RestService<Extension>;

  readonly apiPath = '/api/call_event/v1/extension';

  static postProcess(extensions: Extension[], departments: Department[], costCenters: CostCenter[]): Extension[] {
    extensions.forEach((extension) => {
      const department = departments.find((dep) => dep.id === extension.departmentId);
      if (!isNullOrUndefined(department)) {
        extension.departmentName = department.description;
      } else {
        console.error(`Error trying to find the department(${extension.departmentId}) on: ${JSON.stringify(extension)}`)
      }
      const costCenter = costCenters.find((cc) => cc.id === extension.costCenterId);
      if (!isNullOrUndefined(costCenter)) {

        extension.costCenterName = costCenter.description;
      } else {
        console.error(`Error trying to find the cost center(${extension.costCenterId}) on: ${JSON.stringify(extension)}`)
      }
    });
    return extensions;
  }

  constructor(private httpClient: HttpClient, private ds: DepartmentService, private cs: CostCenterService) {
    this.restHelper = new RestService<Extension>(this.apiPath, httpClient, Extension.fromJSON)
  }

  countByCustomerIdAndNumber(customerId: string, number: PhoneNumber): Observable<number> {
    return this.httpClient.get<CountResponse>(this.apiPath +
      `/count/customer/${customerId}/number/55${number.getLDFormat()}`)
      .map((res: CountResponse) => res.count);
  }

  saveRange(obj: Extension, start: PhoneNumber, end: PhoneNumber): Observable<SuccessErrorHttpResponse> {
    obj.id = '00000000-0000-0000-0000-000000000000';
    return this.httpClient.post<SuccessErrorHttpResponse>(
      this.apiPath + `/start/${start.getCleanE164Format()}/end/${end.getCleanE164Format()}`, obj);
  }

  getAll(): Observable<Extension[]> {
    return this.restHelper.getAll();
  }

  getAllByCustomerId(customerId: string): Observable<Extension[]> {
    return Observable.forkJoin(this.restHelper.getAllByCustomerId(customerId),
      this.ds.getAllByCustomerId(customerId), this.cs.getAllByCustomerId(customerId))
      .map((data) => ExtensionService.postProcess(data[0], data[1], data[2]))
  }

  getById(id: string): Observable<Extension> {
    return this.restHelper.getById(id);
  }

  save(obj: Extension): Observable<Extension> {
    return this.restHelper.save(obj);
  }

  update(obj: Extension): Observable<Extension> {
    return this.restHelper.update(obj);
  }

  delete(obj: Extension): Observable<string> {
    return this.restHelper.delete(obj);
  }
}


export class Extension implements DataOBJ {

  static fromJSON(json: any): Extension {
    const object: Extension = Object.create(Extension.prototype);
    Object.assign(object, json);
    const numberObj: PhoneNumber = PhoneNumber.fromJSON(json.number);
    // console.log(`Got Number: '${json.number}' to '${JSON.stringify(numberObj)}'`);
    object.number = numberObj;
    return object;
  }

  constructor(public id: string, public number: PhoneNumber, public description: string, public customerId: string,
              public departmentId: string, public costCenterId: string, public deleted: boolean,
              public departmentName: string, public costCenterName: string, public userId?: string) {
  }

  getHumanIdentifier() {
    return this.number.getLDFormat() + ' - ' + this.description;
  }
}

export class SuccessErrorHttpResponse {
  constructor(public success: number, public error: number) {
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/extension.service.ts